import React from 'react'
import { Grid as GridBase, styled } from '@mui/material'

export const Root = styled('div')`
  width: 100%;
`

export const GridContainer = styled(props => <GridBase container {...props} />)`
  &.MuiGrid-container {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const GridItem = styled(props => <GridBase item {...props} />)`
  &.MuiGrid-item {
    margin: ${props => props.margin};
    padding: ${props => props.padding};
  }
`

export const Title = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 22px;
  font-weight: bold;
  line-height: 26px;
  margin: 0;
`

export const Subtitle = styled('h2')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 18px;
  font-weight: bold;
  line-height: 21px;
  margin: 0 0 16px;
`

export const Description = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 0;
`

export const CardTitle = styled('h3')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-weight: bold;
  font-size: 18px;
  line-height: 21px;
  margin: 0;
`

export const CardDescription = styled(Description)``

export const ListDetail = styled('p')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 20px;
  margin: 16px 0 8px;
`

export const List = styled('ul')`
  margin: 0;
  padding: 0 0 0 30px;
`
export const OrderedList = styled('ol')`
  margin: 0;
  padding: 0 0 0 30px;
`

export const TableList = styled('ul')`
  margin: 16px 0;
  padding: 0 0 0 10px;
`

export const CardList = styled('ul')`
  margin: 15px 0 0;
  padding: 0 0 0 20px;
`
export const CardOrderList = styled('ol')`
  margin: 15px 0 0;
  padding: 0 0 0 20px;
`

export const Item = styled('li')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 24px;
  padding: 16px 0;
`

export const SmallItem = styled('li')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 16px;
  line-height: 24px;
  padding: 4px 0;
`

export const TableItem = styled('li')`
  color: ${props => props.theme.palette.brand.black1};
  font-family: ${props => props.theme.typography.fontFamily};
  font-size: 14px;
  line-height: 18px;
  padding: 4px 0;
`

export const Link = styled('a')`
  color: ${props => props.theme.palette.brand.primary};
  cursor: pointer;
  text-decoration: underline;

  &:hover {
    color: ${props => props.theme.palette.blue[35]};
  }
`

export const SectionDivider = styled('hr')`
  height: 1px;
  background-color: ${props => props.theme.palette.brand.gray2};
  border: none;
`
export const Strong = styled('span')`
  font-weight: bold;
`
